export const POST_LOGIN = '/auth/login';

export const GET_USERS = '/user';
// export const CREATE_USER = '/user/create'
// export const DELETE_USER = '/user/delete'
// export const UPDATE_USER = '/user/update'
export const GET_SOLUTIONS = '/solution/get-all-solutions';
export const GET_ANNOUNCEMENT = '/announcement';
export const GET_CATEGORIES = '/category';
// export const DELETE_CATEGORY = '/category/delete'
// export const UPDATE_CATEGORY = '/category/update'
export const CREATE_SOLUTION = '/solution';
export const UPLOAD_FILE = '/upload';
export const DELETE_SOLUTION = '/solution/delete';
export const GET_BANNER = '/banner';
export const DELETE_UPLOADS = '/upload/delete';

export const CREATE_MAINTANCE = '/maintance';
export const UPDATE_MAINTANCE = '/maintance/update';

export const REFILL_REQUEST = '/refillRequest';
export const UPDATE_REFILL_REQUEST = '/refillRequest/update';
export const DELETE_REFILL_REQUEST = '/refillRequest/delete';

export const EXTRA_CLEANING_REQUEST = '/extraCleaningRequest';
export const UPDATE_EXTRA_CLEANING_REQUEST = '/extraCleaningRequest/update';
export const DELETE_EXTRA_CLEANING_REQUEST = '/extraCleaningRequest/delete';
export const UPDATE_EXTRA_CLEANING_SETTINGS = '/extraCleaningRequest/settings';
// ============================================================================

export const UPDATE_BOOKINGS_CRON = '/processBooking/fetch';
export const GET_BOOKINGS = '/processBooking';
export const GET_BOOKINGS_SETTINGS = '/processBooking/settings/fetch';
export const UPDATE_PHONE_NUMBER_KROSS = '/processBooking/kross';

export const GET_SHELLY_DEVICES = '/shellyDevices';
export const UPDATE_SHELLY_DEVICES = '/shellyDevices/fetch';
export const GET_BNBLIST = '/bnbList';
export const GET_CEALNING_COST = '/bnbList/update/cleaningFee';
export const GET_DOORLIST = '/doorList';
export const DEL_DOORLIST = '/doorList/delete';
export const CREATE_DOORLIST = '/doorList/create';
export const UPDATE_DOORLIST = '/doorList/update';
export const GET_DOORLIST_BY_BNB = '/doorList/getDoorListByBnBArray/get';
export const CONTACTINFO = '/contactInfo';
export const DOOR_SETTING = '/doorSetting';
export const DOOR_SCRIPT = '/doorScript';

export const CLEANER_SETTING = '/cleanerSetting';

export const QUESTIONS = '/question';
export const DEL_QUESTIONS = '/question/delete';
export const UPDATE_QUESTIONS = '/question/update';
export const AUTH_TOKEN = '/authToken';

export const SPECIAL_ACCESSS = '/specialAccess';
export const SPECIAL_ACCESS_DELETE = '/specialAccess/delete';
export const SPECIAL_ACCESS_UPDATE = '/specialAccess/update';

export const TRAVEL_GUIDE = '/travelGuide';
export const UPDATE_TRAVEL_GUIDE = '/travelGuide/update';

export const CITY = '/city';
export const DELETE_CITY = '/city/delete';
export const UPDATE_CITY = '/city/update';

export const GET_CATEGORIES_OF_CITY = '/category/get-Categories-of-City';

export const CATEGORY = '/category';
export const DELETE_CATEGORY = '/category/delete';
export const UPDATE_CATEGORY = '/category/update';

export const AssignCity = '/assignCity';
export const DELETE_ASSIGN_CITY = '/assignCity/delete';
export const UPDATE_ASSIGN_CITY = '/assignCity/update';

export const REFRESH_CITIES = '/bnbList/saveCity';

export const getBnBCities = '/bnbList/getAllBnBCities';

export const TEXI = '/texi';
export const DELETE_TEXI = '/texi/delete';
export const UPDATE_TEXI = '/texi/update';

export const AROUNDUS = '/aroundUs';
export const DELETE_AROUNDUS = '/aroundUs/delete';
export const UPDATE_AROUNDUS = '/aroundUs/update';

export const REFILL = '/refillItems';
export const DELETE_REFILL = '/refillItems/delete';
export const UPDATE_REFILL = '/refillItems/update';

export const ASSIGN_REFILL = '/assignRefill';
export const DELETE_ASSIGN_REFILL = '/assignRefill/delete';
export const UPDATE_ASSIGN_REFILL = '/assignRefill/update';

export const CLEANING_ITEMS = '/cleaningItem';
export const DELETE_CLEANING_ITEMS = '/cleaningItem/delete';
export const UPDATE_CLEANING_ITEMS = '/cleaningItem/update';

export const ASSIGN_CLEANING = '/assignCleaning';
export const DELETE_ASSIGN_CLEANING = '/assignCleaning/delete';
export const UPDATE_ASSIGN_CLEANING = '/assignCleaning/update';

export const LUGGAGE = '/luggage';
export const DELETE_LUGGAGE = '/luggage/delete';
export const UPDATE_LUGGAGE = '/luggage/update';

export const LUGGAGE_LOGS = '/luggageLogs';

export const GET_BNB_DATA = '/bnbList/bnbData';
export const DELETE_BNB_DATA = '/bnbList/deleteBnB';

export const CREATE_USER = 'user/sign-up';
export const UPDATE_USER = 'user/update';
export const DELETE_USER = 'user/delete';
export const GET_ALL_USER = 'user/getAll';
export const INVALIDATE_ALL_USER_SESSIONS = 'user/invalidate-all-sessions';
export const ROLE = 'role/list';

export const OPEN_AI = 'user/open-ai';

export const CLEANER = '/cleaner';
export const CLEANER_DELETE = '/cleaner/delete';
export const CLEANER_UPDATE = '/cleaner/update';

export const CONTRACTOR = '/contractor';
export const CONTRACTOR_DELETE = '/contractor/delete';
export const CONTRACTOR_UPDATE = '/contractor/update';

export const SPECIAL_CLEANER = '/specialCleaner';
export const SPECIAL_CLEANER_DELETE = '/specialCleaner/delete';
export const SPECIAL_CLEANER_UPDATE = '/specialCleaner/update';

export const REPAIRMAN = '/repairman';
export const REPAIRMAN_DELETE = '/repairman/delete';
export const REPAIRMAN_UPDATE = '/repairman/update';

export const GET_CLEANINGREPORT = '/cleaningReport';
export const GET_AVERAGES = '/cleaningReport/averages';
export const UPDATE_CLEANINGREPORT = '/cleaningReport/update';
export const GET_MONTHLY_STATMENT = '/cleaningReport/monthlyStatment';

export const CLEANER_REPORT_DELETE = '/cleaningReport/delete';

export const FILTER_CLEANER_REPORT = '/cleaningReport/filterCleanerReport';

export const GET_LUGGAGE_DOORLIST = '/luggageDoorList';
export const DEL_LUGGAGE_DOORLIST = '/luggageDoorList/delete';
export const CREATE_LUGGAGE_DOORLIST = '/luggageDoorList/create';
export const UPDATE_LUGGAGE_DOORLIST = '/luggageDoorList/update';

export const GET_PARKING = '/parking';
export const CREATE_PARKING = '/parking';
export const DEL_PARKING = '/parking/delete';
export const UPDATE_PARKING = '/parking/update';

export const GARAGE = '/garage';
export const DELETE_GARAGE = '/garage/delete';
export const UPDATE_GARAGE = '/garage/update';

export const GET_PRIVATE_PARKING = '/privateparking';
export const CREATE_PRIVATE_PARKING = '/privateparking';
export const DEL_PRIVATE_PARKING = '/privateparking/delete';
export const UPDATE_PRIVATE_PARKING = '/privateparking/update';

export const GET_CONVERSATION = '/conversation';
export const UPDATE_UNREAD_COUNT = '/conversation/updateUnreadCount';
export const UPDATE_LAST_SENDER = '/conversation/updateLastSender';
export const SEARCH_CONVERSATION = '/conversation/search';
export const GET_MESSAGES = '/messages';
export const CHECK_WHATSAPP_NUMBER = '/messages/checkWhatsappNumber';

export const GET_REFILL_MAINTANCE_EXTRA_CLEANING = '/processBooking/getRefillMaintanceExtraCleanigById';
export const UPDATE_PROCESS_BOOKINGS = '/processBooking/update';

export const TRASH_MAP = '/trashmap';

export const TRASH_ITEMS = '/trashItem';
export const DELETE_TRASH_ITEMS = '/trashItem/delete';
export const UPDATE_TRASH_ITEMS = '/trashItem/update';

export const TRASH_DAYS = '/trashDays';
export const DELETE_TRASH_DAYS = '/trashDays/delete';
export const UPDATE_TRASH_DAYS = '/trashDays/update';

export const BNB_DETAIL = '/bnbList/bnbDetail';
export const CITY_WISE_BNB = '/bnbList/cityWiseBnB';

export const CLEANER_MESSAGE = '/cleaner/sendCleaningMessage/admin';

export const CLEANER_MESSAGE_TODAY = '/cleaner/sendCleaningMessage/today';
export const CLEANER_MESSAGE_CALENDER = '/cleaner/sendCleaningMessage/calender';
export const CLEANER_MESSAGE_TOMORROW = '/cleaner/sendCleaningMessage/tomorrow';

export const SHELLY_SETTING = '/shellySetting';
export const SMART_THINGS_SETTINGS = '/smartThingSetting';
export const SMART_THINGS_DEVICES = '/smartThingDevices';
export const GET_ALL_SMART_THINGS_DEVICES = '/smartThingDevices/getAll';

export const CHAT_SETTING = '/chatSetting';
export const CHAT_PRESET_MESSAGE = '/chatPresetMessage';

export const GET_SMART_HOME_ROOM = '/smartHomeRoom';
export const CREATE_SMART_HOME_ROOM = '/smartHomeRoom';
export const DEL_SMART_HOME_ROOM = '/smartHomeRoom/delete';
export const UPDATE_SMART_HOME_ROOM = '/smartHomeRoom/update';
export const GET_SMART_HOME_ROOM_BY_BNB = '/smartHomeRoom/getByBnB';

export const CREATE_SMART_HOME_DEVICE = '/smartHomeDevice';

export const GET_SMART_HOME_DEVICE_BY_BNB = '/smartHomeDevice/getByBnB';
export const GET_SMART_HOME_DEVICE_BY_BNB_WITH_ACCESS_TOKEN = '/smartHomeDevice/getByBnBForWeb';
export const DEL_SMART_HOME_DEVICES = '/smartHomeDevice/delete';
export const UPDATE_SMART_HOME_DEVICES = '/smartHomeDevice/update';

export const UPDATE_SMART_HOME_DEVICE_STATUS = '/smartHomeDevice/updateStatus';

export const SMART_HOME_CONTROLS = '/smartHomeDevice/smartHomeControls';

export const CHECK_IN_CHECK_OUT_COUNT = '/processBooking/checkInCheckOutCount';
export const GET_LAST_BNB_CLEANING_AMOUNT = '/processBooking/getLastBnBCleanigAmount';
export const CREATE_EXTRA_CLEANING_REQUEST = '/extraCleaningRequest';

export const CONTRACTS = '/contract/getAllContracts';
export const UPDATE_CONTRACT_DETAILS = '/contract';
export const ADMIN_CORRECT_CONTRACT = '/contract/admin-correction';
export const CONTRACT_PROPERTIES = '/contract/properties';
export const GET_CONTRACT_SETTINGS = '/contract/settings/fetch';
export const UPDATE_CONTRACT_SETTINGS = '/contract/settings';
export const UPDATE_PROPERTY = '/contract/update/property';

export const CONTRACT = '/contractTemplate';
export const DELETE_CONTRACT = '/contractTemplate/delete';
export const UPDATE_CONTRACT = '/contractTemplate/update';
export const DEFAULT_CONTRACT_TEMPLATE = '/contractTemplate/default';

export const TWILIO_SETTING = '/twilioSetting';

export const TWILIO_NUMBER = '/twilioPhoneNumber';
export const DELETE_TWILIO_NUMBER = '/twilioPhoneNumber/delete';
export const UPDATE_TWILIO_NUMBER = '/twilioPhoneNumber/update';
export const TEST_TWILIO_NUMBER = '/twilioPhoneNumber/test';

export const TTLOCK_SETTINGS = '/ttlock-settings';
export const TTLOCK_DEVICES = '/ttlock';

export const CLEANER_OVERVIEW = '/cleaner/overview/locations';

export const DATABASE_COLLECTIONS = '/database/collections';
